import CookieConsent from './cookie_consent.js'
// import ahoy from 'ahoy.js'

function updateAnalytics() {
  if (window.cc.acceptedCategories.indexOf('analytics') == -1) return false

  if (typeof Adcell !== "undefined") Adcell.Tracking.track();

  // ahoy.configure({
  //   visitsUrl: "/poll/visits",
  //   eventsUrl: "/poll/events",
  //   cookies: window.cc.acceptedCategories.indexOf('analytics') != -1,
  //   visitParams: {},
  // });

  // ahoy.trackView();
  // ahoy.trackClicks("a, button, input[type=submit]");
  // ahoy.trackSubmits("form");

  const domainGtag = document.getElementsByName("gtag")[0] ? document.getElementsByName("gtag")[0].content : null
  if (domainGtag) {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', domainGtag);
  }

  const domainMetaPixel = document.getElementsByName("meta_pixel")[0].content
  if (domainMetaPixel) {
    if (typeof fbq !== "undefined") fbq('init', domainMetaPixel);
    if (typeof fbq !== "undefined") fbq('track','PageView');
  }

  window._mfq = window._mfq || [];
  var mf = document.createElement("script");
  mf.type = "text/javascript"; mf.defer = true;
  mf.src = "//cdn.mouseflow.com/projects/a3ab45ea-71da-4cd6-a5b4-6f224cec517c.js";
  document.getElementsByTagName("head")[0].appendChild(mf);
  
}

export default function() {
  if (!window.testEnvironment){
      window.CookieConsent = null
      CookieConsent()
      window.cc = new window.CookieConsent({
        title: "Wir verwenden Cookies 🍪",
        description: `Wir verwenden Cookies. Viele sind notwendig, um die Website und ihre Funktionen zu betreiben, andere sind für statistische oder Marketingzwecke. Mit der Entscheidung "Ablehnen" werden wir Ihre Privatsphäre respektieren und keine Cookies setzen, die nicht für den Betrieb der Seite notwendig sind.`,
        buttons: {
          acceptAll: "Alle akzeptieren",
          acceptSelected: "akzeptieren",
          reject: "Ablehnen",
          showSettings: "Cookie Einstellungen",
          hideSettings: "Schließen",
        },
        categories: {
          essentials: {
            label: "Essentiell",
            description: `Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.`,
            checked: true,
            mandatory: true
          },
          analytics: {
            label: "Statistik",
            description: `Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.`,
            checked: true,
            mandatory: true
          }
        },
      })
    window.cc.on("change", (cc) => {
      updateAnalytics()
    })

    updateAnalytics()
  }
}
